/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import RestlessDisplayProperty from "../../../components/common/RestlessDisplayProperty";
import RestlessDisplayLarge from "../../../components/common/RestlessDisplayLarge";
import { RestlessTable } from "../../../../_metronic/layout/components/Table";
import axios from "axios";
import { fetchImageToken } from "../../../../redux/actions/imageAuth";
import { useDispatch, useSelector } from "react-redux";
import { format } from "date-fns";

export default function PostsDetailsDialog({ row, id, show, onHide }) {
  const [gifUrl, setGifUrl] = useState("");
  const [date, setDate] = useState("");;
  const dispatch = useDispatch();
  const { imageToken, imageTokenLoading } = useSelector((state) => ({
    imageToken: state.imageAuth.imageToken,
    imageTokenLoading: state.imageAuth.imageTokenLoading,
  }));

  //GIF FROM GIPHY MANAGMENT
  useEffect(() => {
    const GIPHY_API_KEY = process.env.REACT_APP_GIPHY_API_KEY;
    let dateCreated = new Date(row.content.created_at);
    setDate(format(dateCreated,  "MMMM dd, yyyy"))
    
    if (!row?.gif_id) return;
    axios
      .get(
        `https://api.giphy.com/v1/gifs/${row.content.gif_id}?api_key=${GIPHY_API_KEY}`
      )
      .then((response) => {
        setGifUrl(response.data.data.images.downsized.url);
      })
      .catch((err) => console.log(err));
  });

  useEffect(() => {
    dispatch(fetchImageToken);
  }, []); 

  const renderImages = (row, imageToken) => {
    return row.content.picture_images.length ? (
      row.content.picture_images.map((img) => {
        return imageTokenLoading ? (
          <span className="mx-3 spinner spinner-primary"></span>
        ) : (
          <img
            alt=""
            style={{
              marginRight: "10px",
              width: "100px",
              height: "100px",
              cursor: "pointer",
            }}
            src={img.formats.small?.url + imageToken}
          />
        );
      })
    ) : (
      <div className="text-muted">This posts has no image</div>
    );
  };

  const renderPolls = (row) => {
    let totalVotes = 0;
    const optionsWithTotal = [];
    row.content.poll.options.map((item) => (totalVotes += item.votes));
    row.content.poll.options.map((item) =>
      optionsWithTotal.push({ ...item, totalVotes: totalVotes })
    );

    const votesFormatter = (cellContent, row, rowIndex) => {
      const totalPercent = (row.votes * 100) / row.totalVotes;
      return (
        <div>
          {cellContent === null ||
          cellContent === undefined ||
          cellContent === 0 ||
          isNaN(totalPercent)
            ? 0 + "%"
            : totalPercent + "%"}
        </div>
      );
    };

    const columns = [
      {
        dataField: "description",
        text: "Options",
        sort: true,
      },
      {
        dataField: "votes",
        text: "Votes",
        sort: true,
        formatter: votesFormatter,
      },
    ];

    return (
      <>
        <div className="row">
          <div className="col-6">{row.content.poll?.body}</div>
          <div className="d-flex col-6  justify-content-end">
            Total Votes: {totalVotes || 0}
          </div>
        </div>
        <RestlessTable data={optionsWithTotal} columns={columns} noSearchBar />
      </>
    );
  };

  const renderVideos = (row, imageToken) => {
    return imageTokenLoading ? (
      <span className="mx-3 spinner spinner-primary"></span>
    ) : (
      <div className="player-wrapper">
        <video width="320" height="240" controls>
          <source src={row.content.video.url + imageToken} type="video/mp4" />
        </video>
      </div>
    );
  };

  return (
    <Modal size="lg" show={show} onHide={onHide}>
      <Modal.Header>
        <div className="d-flex justify-content-center">Report Details</div>
        <div className="d-flex justify-content-center">Reason: {row.reason} </div>
        <div className="d-flex justify-content-center">{date}</div>
      </Modal.Header>
      <Modal.Body>
        {row && (
          <div className="container">
            <div className="row">
              <div className="col">
                <RestlessDisplayProperty label="ID" content={row.content.id} />
              </div>
              <div className="col">
                <RestlessDisplayProperty
                  label="Type"
                  content={row.content.poll ? "Poll" : "Text / Media"}
                />
              </div>
              <div className="col">
                <RestlessDisplayProperty
                  label="Source"
                  content={
                    (row?.type == 'Article' && "Article") ||
                    (row?.type == "Comment" && "Comment") ||
                    (row.type == 'Post' && "Post")
                  }
                />
              </div>
              <div className="col">
                <RestlessDisplayProperty
                  label="Author"
                  content={row.content.restless_user?.full_name}
                />
              </div>
            </div>
            <hr />
            <div className="col">
              <RestlessDisplayLarge
                label="Text"
                content={
                  row.content.body || (
                    <div className="text-muted">This posts has no text</div>
                  )
                }
              />
            </div>
            <div className="col">
              {row.content.poll && (
                <>
                  <h4 className="mb-6">Poll</h4>
                  {renderPolls(row)}
                </>
              )}
              {row.content.picture_images?.length > 0 && (
                <>
                  <h4 className="mb-4">Media</h4>
                  {renderImages(row, imageToken)}
                </>
              )}
              {row.content.gif_id && (
                <>
                  <h4 className="mb-4">Gif</h4>
                  <img
                    src={gifUrl}
                    alt=""
                    style={{
                      marginRight: "10px",
                      width: "200px",
                      height: "200px",
                      cursor: "pointer",
                    }}
                  />
                </>
              )}
              {row.content.video && (
                <>
                  <h4 className="mb-4">Video</h4>
                  {renderVideos(row, imageToken)}
                </>
              )}
            </div>
            <hr />
            <div className="row">
              <div className="col-12">
                <h4 className="mb-4">Observations</h4>
              </div>
              <div className="col">
                <RestlessDisplayProperty
                    content={row.explanation || (
                      <div className="text-muted">This report has no observations</div>
                    )}
                  />
              </div>
     
            </div>
            <hr />
            <div className="row">
              <div className="col-12">
                <h4 className="mb-4">Stats</h4>
              </div>
              <div className="col">
                <RestlessDisplayProperty
                  label="Reactions"
                  content={row.content.reactions || 0}
                />
              </div>
              <div className="col">
                <RestlessDisplayProperty
                  label="Comments"
                  content={row.content.info?.comments || 0}
                />
              </div>
              <div className="col">
                <RestlessDisplayProperty
                  label="Reports"
                  content={row.content.reports || 0}
                />
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn btn-secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
